<template>
  <footer class="site-footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section about">
          <h3 class="footer-title">关于我们</h3>
          <div class="contact-info">
            <div class="contact-item">
              <span class="icon">
                <img src="http://www.gzhr.org.cn/api/images/view/1747972894307-31161211.png?token=07d2eeacd288a2b33a8c0b197d24ffff6942c238b5d7c687f4d111f51dabcacd" alt="地址" class="icon-img">
              </span>
              <span>地址：广州市越秀区解放南路123号金汇大厦6楼604</span>
            </div>
            <div class="contact-item">
              <span class="icon">
                <img src="http://www.gzhr.org.cn/api/images/view/1747972901516-615088972.png?token=64478a1e73b56901bba3f474b275d66ece22828eb863aa2b95510b83ce99b665" alt="电话" class="icon-img">
              </span>
              <span>电话：020-83825060</span>
            </div>
            <div class="contact-item">
              <span class="icon">
                <img src="http://www.gzhr.org.cn/api/images/view/1747972917396-353685799.png?token=9c553eedd68b1a7a01bc64acb8b73f6cf3ffaa3bcd3faca2305c98fedbc716a5" alt="邮箱" class="icon-img">
              </span>
              <span>邮箱：hr@gzhr.org.cn</span>
            </div>
          </div>
        </div>
        
        <div class="footer-section links">
          <h3 class="footer-title">快速链接</h3>
          <ul class="footer-links">
            <li><router-link to="/about">机构简介</router-link></li>
            <li><router-link to="/news">新闻资讯</router-link></li>
            <li><router-link to="/dynamics">学会动态</router-link></li>
            <li><router-link to="/policy">政策法规</router-link></li>
            <li><router-link to="/case-law">案例分析</router-link></li>
            <li><router-link to="/member-services">会员服务</router-link></li>
            <!-- <li><router-link to="/contact">联系我们</router-link></li> -->
          </ul>
        </div>
        
      </div>
      
      <div class="footer-bottom">
        <p>Copyright &copy; 2020-2026 广州市劳动保障学会</p>
        <p><a href="https://beian.miit.gov.cn/">国家工信部备案号: 粤ICP备20002167号-1</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
import { IMAGES } from '@/assets/images/placeholder.js'

export default {
  name: 'SiteFooter',
  data() {
    return {
      icons: IMAGES.icons
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.site-footer {
  background: linear-gradient(135deg, #26324a 0%, #2d3748 100%);
  color: #cbd5e0;
  padding: 12px 0 15px;
  position: relative;
  box-shadow: 0 -2px 16px 0 rgba(0,0,0,0.08);
  font-family: 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #1d7dd8, #2d8cf0, #5cadff);
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;
  }

  .footer-content {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -15px 15px;
    border-radius: 8px;
    box-shadow: 0 2px 16px 0 rgba(0,0,0,0.04);
    padding: 15px 0 8px;
  }

  .footer-section {
    flex: 1;
    min-width: 280px;
    padding: 0 15px;
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .footer-section.about {
    flex: 0.8;
  }

  .footer-section.links {
    flex: 1.2;
    min-width: 320px;
  }

  .footer-section.search {
    flex: 1.2;
    min-width: 320px;
  }

  .footer-title {
    position: relative;
    font-size: 18px;
    margin-bottom: 15px;
    padding-bottom: 8px;
    color: #fff;
    font-weight: 700;
    letter-spacing: 1px;
    text-shadow: 0 2px 8px rgba(0,0,0,0.08);
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 48px;
      height: 3px;
      background: linear-gradient(90deg, #2d8cf0, #5cadff);
      border-radius: 2px;
    }
  }

  .contact-info {
    .contact-item {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      font-size: 14px;
      color: #e2e8f0;
      line-height: 1.4;
      .icon {
        margin-right: 10px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        flex-shrink: 0;
        margin-top: 2px;
        border-radius: 50%;
        box-shadow: 0 1px 4px rgba(45,140,240,0.08);
        .icon-img {
          width: 40px;
          height: 40px;
          filter: brightness(1.2);
          object-fit: contain;
        }
      }
    }
  }

  .footer-links {
    list-style: none;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, auto);
    gap: 8px 15px;
    li {
      margin-bottom: 0;
      transition: transform 0.2s;
      &:hover {
        transform: translateX(4px) scale(1.02);
      }
    }
    a {
      color: #cbd5e0;
      transition: color 0.3s;
      display: block;
      padding: 4px 0 4px 15px;
      position: relative;
      font-size: 13.5px;
      font-weight: 500;
      letter-spacing: 0.3px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: left;
      &:before {
        content: '›';
        position: absolute;
        left: 2px;
        top: 2px;
        color: #2d8cf0;
        font-size: 15px;
        font-weight: bold;
      }
      &:hover {
        color: #fff;
        text-shadow: 0 2px 8px #2d8cf033;
      }
    }
  }

  .footer-bottom {
    text-align: center;
    padding-top: 12px;
    border-top: 1px solid rgba(255,255,255,0.08);
    p {
      font-size: 13px;
      margin: 3px 0;
      color: rgba(255,255,255,0.5);
      letter-spacing: 0.3px;
    }
  }
  .footer-bottom a,
  .footer-bottom a:hover,
  .footer-bottom a:active,
  .footer-bottom a:focus {
    color: #cbd5e0 !important;
    text-shadow: none !important;
    text-decoration: none !important;
  }

  .footer-search {
    display: flex;
    margin-bottom: 8px;

    .search-input {
      flex: 1;
      padding: 10px 14px;
      border-radius: 20px 0 0 20px;
      border: 1px solid rgba(255,255,255,0.3);
      background: rgba(15,23,42,0.6);
      color: #e2e8f0;
      font-size: 14px;
      outline: none;
      transition: all 0.2s;

      &::placeholder {
        color: rgba(148,163,184,0.9);
      }

      &:focus {
        border-color: #5cadff;
        background: rgba(15,23,42,0.9);
        box-shadow: 0 0 0 1px rgba(92,173,255,0.35);
      }
    }

    .search-btn {
      padding: 10px 18px;
      border-radius: 0 20px 20px 0;
      border: none;
      background: linear-gradient(90deg, #2d8cf0, #5cadff);
      color: #fff;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background: linear-gradient(90deg, #1d7dd8, #3a9bff);
        transform: translateY(-1px);
        box-shadow: 0 4px 10px rgba(15,23,42,0.45);
      }

      &:active {
        transform: translateY(0);
        box-shadow: none;
      }
    }
  }

  .search-tip {
    margin: 4px 0 0;
    font-size: 12px;
    color: rgba(203,213,225,0.9);
  }
}
</style> 